import React from "react";
import SectionHead from "../ui/SectionHead";
import SelectCard from "../ui/SelectCard";
import Input from "../ui/Input";

export default function AppointmentStep({ step, answers, setField, onContinue }) {
  const dateKey = step.fields.date;
  const timeKey = step.fields.time;
  const durKey = step.fields.duration;

  const DateIcon = step.icons?.date;
  const TimeIcon = step.icons?.time;

  return (
    <div>
      <SectionHead title={step.subtitle} subtitle="Bitte wählen Sie alle Felder aus." />

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-900">
            {DateIcon ? <DateIcon /> : null}
            Datum
          </div>
          <Input
            label="Wunschtermin"
            type="date"
            value={answers[dateKey] || ""}
            onChange={(v) => setField(dateKey, v)}
          />
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
          <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-900">
            {TimeIcon ? <TimeIcon /> : null}
            Uhrzeit
          </div>
          <Input
            label="Uhrzeit"
            type="time"
            value={answers[timeKey] || ""}
            onChange={(v) => setField(timeKey, v)}
          />
        </div>
      </div>

      <div className="mt-5">
        <div className="mb-3 text-sm font-semibold text-slate-900">Dauer</div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {step.durationOptions.map((opt) => {
            const Icon = opt.icon;
            return (
              <SelectCard
                key={opt.key}
                title={opt.label}
                subtitle="Dauer auswählen"
                icon={<Icon />}
                selected={String(answers[durKey] || "") === String(opt.key)}
                onClick={() => setField(durKey, opt.key)}
              />
            );
          })}
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button
          type="button"
          onClick={onContinue}
          className="inline-flex items-center justify-center rounded-xl bg-[#0b2b40] px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-emerald-600/20 hover:bg-[#0b2b40]/90"
        >
          Weiter
        </button>
      </div>
    </div>
  );
}
